import { Component, createRef, RefObject } from 'react';
import { IProductModifier, IProductModifierOption } from 'src/types/products';
import MultiChoise from 'src/view/components/Controls/MultiChoise/MultiChoise';
import SignleChoise from 'src/view/components/Controls/SignleChoise/SignleChoise';

interface IProps {
  modifier: IProductModifier;
  errors: IProductModifier['id'][];
  needScrollToError?: boolean;
  className?: string;
  readOnly?: boolean;
  onModifierChange: (modifier: IProductModifier) => void;
  setNeedScrollToError?: (need: boolean) => void;
}

export default class ProductModifier extends Component<IProps, {}> {
  modifierContainerRef: RefObject<HTMLDivElement>;

  constructor(props: IProps) {
    super(props);

    this.modifierContainerRef = createRef();
  }

  scrollOnError = () => {
    if (
      this.props.errors.includes(this.props.modifier.id) &&
      this.props.needScrollToError &&
      this.props.setNeedScrollToError
    ) {
      this.modifierContainerRef.current?.scrollIntoView({ behavior: 'smooth' });
      this.props.setNeedScrollToError(false);
    }
  };

  componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<{}>, snapshot?: any) {
    this.scrollOnError();
  }

  /**
   * Number of options, that user can add to this modifier
   * It includes modifiers.maximum and selected options quantity
   *
   * @readonly
   * @memberof ProductModifier
   */
  get optionsLeftToMaximum() {
    const { modifier } = this.props;
    // For select any amount
    if (modifier.maximum === 0) {
      return null;
    }
    const numberOfSelectedOptions = modifier.options.reduce((count: number, option: IProductModifierOption) => {
      if (option.selected) {
        count = count + option.quantity;
      }
      return count;
    }, 0);
    return modifier.maximum - numberOfSelectedOptions;
  }

  render() {
    const { modifier, readOnly } = this.props;
    const error = this.props.errors.includes(modifier.id);
    const ModifierComponent = modifier.multi_choice ? MultiChoise : SignleChoise;

    return (
      <div ref={this.modifierContainerRef} className={this.props.className}>
        <ModifierComponent
          error={error}
          onChange={this.props.onModifierChange}
          modifier={modifier}
          leftToMaximum={this.optionsLeftToMaximum}
          readOnly={readOnly}
        />
      </div>
    );
  }
}
